export default __webpack_public_path__ + "static/media/logo-white.fd01f4ee.png";